var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LazyHydrate',{attrs:{"when-visible":""}},[_c(_vm.componentDisplay,_vm._b({tag:"component"},'component',{ sectionData: _vm.componentData, isLastItem: _vm.isLastItem, mainLevelName: _vm.mainLevelName },false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }